import { render, staticRenderFns } from "./order-status-add.vue?vue&type=template&id=2402effc&"
import script from "./order-status-add.vue?vue&type=script&lang=js&"
export * from "./order-status-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2402effc')) {
      api.createRecord('2402effc', component.options)
    } else {
      api.reload('2402effc', component.options)
    }
    module.hot.accept("./order-status-add.vue?vue&type=template&id=2402effc&", function () {
      api.rerender('2402effc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/order-status/order-status-add.vue"
export default component.exports